const IconArrow = ({className = '', ...props}) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.43 31.08"
      fill="none"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      className={className}
      {...props}
    >
      <polyline points="2 29.08 15.43 15.43 2 2" />
    </svg>
  );
  
export default IconArrow;  